import React from 'react';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { AlternativeTable } from 'components';
import useStatsList from 'hooks/useStatsList';
import useInfinityScroll from 'hooks/useInfinityScroll';
import { StandStatsType, columns } from './columns';
import { Props } from '../types';

const statsPath = 'standStats';
const itemsKey = 'standStatistics';

const StandStats = ({ employeeId }: Props) => {
  const { items, total, isLoading, handleLoadMore } = useStatsList({
    statsPath,
    itemsKey,
    itemsPerPage: 10,
    employeeId
  });

  const table = useReactTable({
    data: items as StandStatsType[],
    columns,
    getCoreRowModel: getCoreRowModel()
  });

  const { containerRef, fetchMoreOnBottomReached } = useInfinityScroll({
    onLoadMore: handleLoadMore,
    totalDBRowCount: total,
    totalFetched: items.length,
    isFetching: isLoading
  });

  return (
    <AlternativeTable
      config={table}
      ref={containerRef}
      fetchMoreOnBottomReached={fetchMoreOnBottomReached}
      isLoading={isLoading}
    />
  );
};

export default StandStats;
